export class IncidentResponse {
  incidentResponseId?: number;
  incidentResponseNumber?: string;
  type?: string;
  occuredDate?: Date
  reportedDate?: string;
  severityLevel?: string;
  reportedBy?: string;
  systemsAndServicesImpacted?: string;
  initialReporting?: string;
  incidentSequenceOfEvents?: string;
  incidentMitigation?: string;
  documentation?: string;
  recommendations?: string;
  additionalCommentsNotes?: string;
  attachments: any[];
  approver1Id?: number;
  approver2Id?: number;
  approved1Date?: string;
  approved2Date?: string;
  isApproved1?: boolean;
  isApproved2?: boolean;
}
